/* Mom's Home – return shoppers to the same spot on a collection/home page after viewing a product.
   v2 (Round 7, 25-Oct-26). Works for: browser/phone Back (incl. bfcache, iOS swipe, Android back,
   reload-then-back) and for links back to the same collection (breadcrumb, pills, menu) within 30 min
   of opening a product from it. Saves to sessionStorage + localStorage (in-app browsers). */
(function () {
  'use strict';
  if (window.__mhsr) return; window.__mhsr = 1;

  var TTL = 30 * 60 * 1000;
  var PFX = 'mhsr2:';
  var LAST = 'mhsr2:last';
  var RAILS = '[data-mhh-track], slider-component .slider, .slider--mobile';
  var DROP = /^(preview_theme_id|page|section_id|utm_.*|fbclid|gclid|ttclid|_pos|_sid|_ss|_psq|_fid|variant)$/;

  function norm(u) {
    try {
      var url = new URL(u, location.href);
      var p = url.pathname.replace(/\/+$/, '') || '/';
      var keep = [];
      url.searchParams.forEach(function (v, k) { if (!DROP.test(k)) keep.push(k + '=' + v); });
      keep.sort();
      return p + (keep.length ? '?' + keep.join('&') : '');
    } catch (e) { return location.pathname; }
  }
  var HERE = norm(location.href);
  var KEY = PFX + HERE;

  function put(k, obj) {
    var s = JSON.stringify(obj);
    try { sessionStorage.setItem(k, s); } catch (e) {}
    try { localStorage.setItem(k, s); } catch (e) {}
  }
  function get(k) {
    var raw = null;
    try { raw = sessionStorage.getItem(k); } catch (e) {}
    if (!raw) { try { raw = localStorage.getItem(k); } catch (e) {} }
    if (!raw) return null;
    try { var o = JSON.parse(raw); return o && Date.now() - o.ts < TTL ? o : null; } catch (e) { return null; }
  }
  function del(k) {
    try { sessionStorage.removeItem(k); } catch (e) {}
    try { localStorage.removeItem(k); } catch (e) {}
  }

  function gridUl() { return document.querySelector('ul#product-grid'); }
  function count() { var g = gridUl(); return g ? g.children.length : 0; }
  function rails() { return Array.prototype.slice.call(document.querySelectorAll(RAILS)); }
  function handleOf(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? m[1] : null; }
  function isPdp() { return /\/products\/[^/]+/.test(location.pathname); }

  var restoring = false;
  var lastClick = null; // {handle, top}

  function snapshot() {
    var prev = get(KEY) || {};
    return {
      y: window.scrollY || window.pageYOffset || 0,
      n: count(),
      rails: rails().map(function (r) { return r.scrollLeft || 0; }),
      handle: lastClick ? lastClick.handle : (prev.handle || null),
      top: lastClick ? lastClick.top : (prev.top || null),
      ts: Date.now()
    };
  }
  function save() { if (!restoring && !isPdp()) put(KEY, snapshot()); }

  function onProductPress(e) {
    if (isPdp() || restoring) return;
    var a = e.target && e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) return;
    var h = handleOf(a.getAttribute('href'));
    if (!h) return;
    var card = a.closest('li, .mhc, .card-wrapper, .grid__item') || a;
    lastClick = { handle: h, top: Math.round(card.getBoundingClientRect().top) };
    put(KEY, snapshot());
    put(LAST, { from: HERE, handle: h, ts: Date.now() });
  }
  ['pointerdown', 'touchstart', 'mousedown', 'click'].forEach(function (t) {
    document.addEventListener(t, onProductPress, { capture: true, passive: true });
  });
  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') save(); });
  var st = null;
  window.addEventListener('scroll', function () {
    if (st || restoring) return;
    st = setTimeout(function () { st = null; save(); }, 400);
  }, { passive: true });

  /* ---------- restore ---------- */
  function navType() {
    try {
      var n = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (n && n.type) return n.type;
      var t = performance.navigation && performance.navigation.type;
      return t === 2 ? 'back_forward' : t === 1 ? 'reload' : 'navigate';
    } catch (e) { return 'navigate'; }
  }
  function fromProductLink() {
    var last = get(LAST);
    if (!last || last.from !== HERE) return false;
    var ref = document.referrer || '';
    try { if (ref && new URL(ref).host !== location.host) return false; } catch (e) {}
    return /\/products\//.test(ref) || ref === '';
  }

  var overlay = null;
  function showLoader() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(255,255,255,.92);display:flex;align-items:center;justify-content:center';
    overlay.innerHTML = '<div style="width:34px;height:34px;border:3px solid #e5ded8;border-top-color:#2b211b;border-radius:50%;animation:mhsrspin .7s linear infinite"></div><style>@keyframes mhsrspin{to{transform:rotate(360deg)}}</style>';
    (document.body || document.documentElement).appendChild(overlay);
  }
  function hideLoader() { if (overlay) { overlay.remove(); overlay = null; } }

  function pageUrl(base, n) {
    var u = new URL(base, location.href);
    u.searchParams.set('page', String(n));
    return u.pathname + u.search;
  }

  // Load pages 2..k in parallel and append in order; keeps the infinite-scroll button in sync.
  function loadTo(target) {
    var btn = document.querySelector('[data-load-more-button]');
    var ul = gridUl();
    if (!btn || !ul || count() >= target) return Promise.resolve();
    var wrapper = btn.closest('[data-load-more-id]');
    var sectionId = wrapper && wrapper.dataset.loadMoreId;
    var next = btn.dataset.nextUrl;
    if (!sectionId || !next) return Promise.resolve();
    var startPage = parseInt(new URL(next, location.href).searchParams.get('page') || '2', 10);
    var per = Math.max(1, count() / Math.max(1, startPage - 1));
    var lastPage = startPage - 1 + Math.ceil((target - count()) / per);
    if (lastPage - startPage > 40) lastPage = startPage + 40;
    btn.setAttribute('disabled', 'disabled');
    var jobs = [];
    for (var p = startPage; p <= lastPage; p++) {
      (function (pg) {
        var u = pageUrl(next, pg);
        jobs.push(fetch(u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); })
          .catch(function () { return null; }));
      })(p);
    }
    return Promise.all(jobs).then(function (docs) {
      var lastDoc = null;
      docs.forEach(function (doc) {
        if (!doc) return;
        var nu = doc.querySelector('ul#product-grid');
        if (nu) { Array.prototype.slice.call(nu.children).forEach(function (li) { ul.appendChild(li); }); lastDoc = doc; }
      });
      var nb = lastDoc && lastDoc.querySelector('[data-load-more-button]');
      if (lastDoc && nb && nb.dataset.nextUrl) {
        btn.dataset.nextUrl = nb.dataset.nextUrl;
        btn.removeAttribute('disabled');
        if (window.LoadMoreProducts && window.LoadMoreProducts.reobserve) window.LoadMoreProducts.reobserve(wrapper);
      } else if (lastDoc) {
        if (window.LoadMoreProducts && window.LoadMoreProducts.unobserve) window.LoadMoreProducts.unobserve(wrapper);
        wrapper.remove();
      } else {
        btn.removeAttribute('disabled');
      }
    });
  }

  function findCard(handle) {
    if (!handle) return null;
    var a = document.querySelector('ul#product-grid a[href*="/products/' + handle + '"]') ||
            document.querySelector('main a[href*="/products/' + handle + '"]');
    return a ? (a.closest('li, .mhc, .card-wrapper, .grid__item') || a) : null;
  }
  function jump(d) {
    var list = rails();
    (d.rails || []).forEach(function (x, i) { if (x && list[i]) list[i].scrollLeft = x; });
    var card = findCard(d.handle);
    var y = d.y;
    if (card && typeof d.top === 'number') {
      y = card.getBoundingClientRect().top + (window.scrollY || 0) - d.top;
    }
    window.scrollTo(0, Math.max(0, y));
  }

  function restore(d) {
    if (!d) return;
    restoring = true;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var needLoad = d.n && count() && d.n > count() && document.querySelector('[data-load-more-button]');
    if (needLoad) showLoader();
    (needLoad ? loadTo(d.n) : Promise.resolve()).then(function () {
      jump(d);
      requestAnimationFrame(function () { jump(d); hideLoader(); });
      setTimeout(function () { jump(d); restoring = false; }, 400);
      window.addEventListener('load', function () { if (Math.abs((window.scrollY || 0) - d.y) > 2) jump(d); }, { once: true });
    }, function () { hideLoader(); restoring = false; });
  }

  function start() {
    if (isPdp()) return;
    var d = get(KEY);
    if (!d) return;
    var t = navType();
    if (t === 'back_forward' || t === 'reload') { restore(d); return; }
    if (fromProductLink()) { del(LAST); restore(d); }
  }

  if (!isPdp()) {
    var t0 = navType();
    if ((t0 === 'back_forward' || t0 === 'reload' || fromProductLink()) && get(KEY) && 'scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // bfcache: DOM is intact; just make sure we are at the saved spot.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || isPdp()) return;
    restoring = false;
    var d = get(KEY);
    if (d && Math.abs((window.scrollY || 0) - d.y) > 40) jump(d);
  });
})();
